import { FC, ReactNode, useCallback, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './styles.scss';

type Props = {
  title: string;
  children: ReactNode;
};

const SidebarTooltip: FC<Props> = ({ title, children }) => {
  const anchorRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState<{ top: number; left: number } | null>(null);

  const show = useCallback((): void => {
    const rect = anchorRef.current?.getBoundingClientRect();

    if (rect) {
      setPosition({ top: rect.top + rect.height / 2, left: rect.right + 8 });
    }
  }, []);

  const hide = useCallback((): void => setPosition(null), []);

  return (
    <>
      <div
        ref={anchorRef}
        className="sidebar_section__item"
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
      >
        {children}
      </div>
      {position && title
        ? createPortal(
            <div className="sidebar_tooltip_bubble" style={{ top: position.top, left: position.left }} role="tooltip">
              {title}
            </div>,
            document.body
          )
        : null}
    </>
  );
};

export default SidebarTooltip;
